// export const host = 'https://test.m.tender.pro/api';
export const host = 'https://test.m.tender.pro/api';
// export const host = 'http://192.168.0.100:8000/api';

